import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { Grid, Button, Typography, Box } from "@mui/material";
import { USERS_API } from "../api";
import { addErrorMessage, addNewMessage } from "../slice";
import { useRemainedSecond } from "../hooks";
import Input from "../components/Input";
import { ReactComponent as Logo1 } from "../assets/images/Logo_1.svg";
import ReCAPTCHA from "react-google-recaptcha";
import Footer from "./Footer";

function ForgetPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setRemained_second } = useRemainedSecond();
  const recaptcha = useRef();
  const [captchaToken, setCaptchaToken] = useState();

  const { mutate: forgetPassword } = useMutation((body) => USERS_API.ForgotPassword(body), {
    onError: ({ response: { data } }) => {
      dispatch(
        addNewMessage({
          id: "no-user",
          text: data?.message,
          type: "error",
        })
      );
      recaptcha.current.reset();
      setRemained_second(data?.data.validSeconds);
      navigate("/verification-code");
    },
    onSuccess: ({ data }) => {
      setRemained_second(data?.data.validSeconds);
      navigate("/verification-code");
    },
  });

  const handleSubmitForm = (event) => {
    event.preventDefault();
    let body = {
      email: "",
      phoneNumber: "",
    };
    if (
      String(event.target.userName.value)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) !== null
    ) {
      body.email = event.target.userName.value;
      window.sessionStorage.setItem("email", body.email);
      window.sessionStorage.setItem("action-type", "forgetPassword_email");
      window.sessionStorage.removeItem("phoneNumber");
    } else if (
      String(event.target.userName.value).match(
        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
      ) !== null
    ) {
      body.phoneNumber = event.target.userName.value;
      window.sessionStorage.setItem("phoneNumber", body.phoneNumber);
      window.sessionStorage.setItem("action-type", "forgetPassword_phoneNumber");
      window.sessionStorage.removeItem("email");
    }
    //todo: inja byd data haye dakhel form verfiy beshan
    if (!recaptcha.current.getValue()) {
      dispatch(
        addErrorMessage({ status: 400, data: { message: "لطفا من ربات نیستم را انتخاب کنید." } })
      );
    } else {
      forgetPassword({ ...body, captchaToken });
    }
  };

  return (
    <Grid
      container
      maxWidth="1920px"
      width="100%"
      minHeight="100vh"
      bgcolor={{ xs: "#fff", sm: "#FAFAFA", md: "#FAFAFA" }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      fontFamily="VazirMedium"
    >
      <Box
        container
        xs={4}
        bgcolor="#fff"
        borderRadius={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        py={{ xs: 1, sm: 5, md: 4 }}
        px={{ xs: 1, sm: 4, md: 6 }}
        my={5}
      >
        <Logo1 />
        <Typography variant="h1" mt={10} mb={2}>
          فراموشی رمز عبور
        </Typography>
        <Typography variant="h2" my={2} textAlign="center">
          برای این کار شماره تلفن خود را وارد کنید
        </Typography>
        <form onSubmit={handleSubmitForm}>
          <Input placeholder="شماره تلفن" width={"248px"} name="userName" flex={4} type="number" />
          <Grid
            container
            className="captcha"
            style={{ transform: "scale(0.815)", transformOrigin: "0 0", marginTop: "0.5rem" }}
          >
            <ReCAPTCHA
              sitekey="6LfjzkopAAAAAMVFkngsSsFNBRsNZin7b991NfVA"
              ref={recaptcha}
              style={{
                width: "30px",
              }}
              hl="fa"
              onChange={(data) => {
                setCaptchaToken(data);
              }}
            ></ReCAPTCHA>
          </Grid>
          <Button type="submit" variant="l" sx={{ mt: 1.5, mb: 3 }}>
            بعدی
          </Button>
        </form>
      </Box>
      <Footer />
    </Grid>
  );
}

export default ForgetPassword;
